const TOAST_EVENT = 'gnosis-toast';

/**
 * Raise a transient confirmation from anywhere, without threading a callback
 * through every component between here and the app shell. AppShell listens and
 * renders it with the same styling as the "added to your library" toast.
 */
export function showToast(message: string): void {
  window.dispatchEvent(new CustomEvent<string>(TOAST_EVENT, { detail: message }));
}

export function onToast(handler: (message: string) => void): () => void {
  const listener = (e: Event) => handler((e as CustomEvent<string>).detail);
  window.addEventListener(TOAST_EVENT, listener);
  return () => window.removeEventListener(TOAST_EVENT, listener);
}
